import LogoutPage from './LogoutPage';

export default LogoutPage;
